import React from "react";
import { FC } from "react";
import { Button, Container, Navbar } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useGoalsById } from "../queries/goal-queries";
import { useDeleteGoalMutation } from "../mutators/goal-mutators";

export const GoalDetails: FC = () => {

    const { id } = useParams<{ id: string }>();
    const { goal } = useGoalsById(id);
    const deleteGoal = useDeleteGoalMutation()
    const nav = useNavigate();

    if (!id || !goal) {
        return (<></>)
    }

    return (
        <>
            <Navbar sticky="top" key={'nav-bar'} expand={false} className="bg-body-secondary mb-3">
                <Container fluid>
                    <h2 className="mb-0">{goal.title}</h2>
                </Container>
            </Navbar>

            <div className="pt-3">
                <Button variant="danger" className="w-100" onClick={() => deleteGoal.mutateAsync(id).then(() => nav('/stats'))}>Delete</Button>
            </div>
        </>
    )
}